import React, { useState, useEffect } from 'react';

interface TextInputProps {
  id : string;
  value : string;
  onSaveValue : (value : string) => void;
}

export function TextInputComponent({
  id,
  value,
  onSaveValue,
} : TextInputProps) : JSX.Element {

  const [currentValue, setCurrentValue] = useState<string>('');

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  return (
    <input
      id={id}
      type="text"
      value={currentValue}
      onChange={(event) => setCurrentValue(event.target.value)}
      onBlur={() => onSaveValue(currentValue)}
    />
  );
}
